import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  SelectOption, SingleSelect,
} from 'react-select-material-ui';
import {
  images,
} from '../../assets/image';
import PageTitleWithBackButton from '../../components/PageTitleWithBackButton/PageTitleWithBackButton';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IAuthStore, ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  IBannerAdsStore,
} from '../../mobx-store/storeInterfaces/bannerAdsInterface';
import {
  IHomeStore, IPostSubmission,
} from '../../mobx-store/storeInterfaces/homeInterface';
import {
  INewsAndAnnouncementStore,
} from '../../mobx-store/storeInterfaces/newsAndAnnouncementInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import classes from './createHomeCards.module.scss';

interface IProps extends WithSnackbarProps {
  homeStore: IHomeStore;
  countryStore: CountryStore;
  bannerAdsStore: IBannerAdsStore;
  authStore: IAuthStore;
  newsAndAnnouncementStore: INewsAndAnnouncementStore;
  history: any;
  match: any;
}

interface IState {
  value: number;
  articleId: number;
  advertisementId: number;
  image: (File & {
    preview: string;
  })[];
  externalLink: string;
  articleId_2: number;
  isExternal: boolean;
  entityType: string;
  entityId: number;
  internalArticleId: number;
  internalBranchId: number;
  internalAcademyId: number;
  article: any;
  ad: any;
  article2: any;
}

@inject('homeStore', 'newsAndAnnouncementStore', 'bannerAdsStore', 'authStore', 'countryStore')
@observer
class Home extends Component<IProps, IState> {
  currentList = [{
    name: 'Single Article', value: 1,
  }, {
    name: 'Single Ad', value: 2,
  },
  {
    name: 'Article + Ad', value: 3,
  }, {
    name: 'Double Article', value: 4,
  }];

  title: string;

  entityTypes = [
    {
      name: 'Article', value: 'article',
    },
    {
      name: 'Branch', value: 'branch',
    },
    {
      name: 'Academy', value: 'academy',
    },
  ];

  constructor(props: IProps) {
    super(props);
    this.title = translate('homeListPageTitle', {
    });
    this.state = {
      value: 1,
      articleId: 0,
      advertisementId: 0,
      image: [],
      externalLink: '',
      articleId_2: 0,
      isExternal: true,
      entityType: '',
      entityId: 0,
      internalArticleId: 0,
      internalBranchId: 0,
      internalAcademyId: 0,
      article: {
      },
      ad: {
      },
      article2: {
      },
    };
  }

  submitHomeFeedPost = async () => {
    const submission: IPostSubmission = {
      availableCountries: this.props.countryStore.managedCountries.map((country: ICountry) => country.isoCode),
      type: this.state.value,
      card: {
        item: '',
      },
    };
    let error = false;
    switch (this.state.value) {
      case 1:
        // type 1
        if (this.state.articleId > 0) {
          submission.card.item = `${this.state.articleId}`;
        } else {
          error = true;
        }
        break;
      case 2:
        // type 2
        if (this.state.advertisementId > 0) {
          submission.card.item = `${this.state.advertisementId}`;
        } else {
          error = true;
        }
        break;
      case 3:
        // type 3
        if (this.state.articleId > 0 && this.state.advertisementId > 0) {
          submission.card.item = `${this.state.articleId}`;
          submission.card.itemTwo = `${this.state.advertisementId}`;
        } else {
          error = true;
        }
        break;
      case 4:
        // type 4
        if (this.state.articleId > 0 && this.state.articleId_2 > 0) {
          submission.card.item = `${this.state.articleId}`;
          submission.card.itemTwo = `${this.state.articleId_2}`;
        } else {
          error = true;
        }
        break;
      default:
        // do nothing
        break;
    }

    console.log(this.state, submission);
    if (!error) {
      await this.props.homeStore.postHomeCard(submission);
      this.props.history.goBack();
    }
  };

  handleAddImageToGalleryInCaseOfLimit = (prop: string, imageFile: File) => {
    const file = Object.assign(imageFile, {
      preview: URL.createObjectURL(imageFile),
    });
    const newState: any = {
      [prop]: [file],
    };
    this.setState(newState);
  };

  handleState = async (val: any, type: any, itemType?: string) => {
    switch (type) {
      case 1:
        this.setState({
          articleId: val,
        });
        await this.props.newsAndAnnouncementStore.getArticleById(val, 'news');
        const article = this.props.newsAndAnnouncementStore.selectedArticle;
        console.log(article);
        this.setState({
          article,
        });
        break;
      case 2:
        this.setState({
          advertisementId: val.target.value,
        });
        await this.props.bannerAdsStore.getAdById(val.target.value);
        const ad = this.props.bannerAdsStore.selectedAd;
        this.setState({
          ad,
        });
        break;
      case 3:
        if (itemType === 'article') {
          this.setState({
            articleId: val.target.value,
          });
          await this.props.newsAndAnnouncementStore.getArticleById(val.target.value, 'news');
          const articleDetails = this.props.newsAndAnnouncementStore.selectedArticle;
          console.log(articleDetails);
          this.setState({
            article: articleDetails,
          });
        } else {
          this.setState({
            advertisementId: val.target.value,
          });
          await this.props.bannerAdsStore.getAdById(val.target.value);
          const itemAd = this.props.bannerAdsStore.selectedAd;
          this.setState({
            ad: itemAd,
          });
        }
        break;
      case 4:
        this.setState({
          articleId: val.target.value,
        });
        await this.props.newsAndAnnouncementStore.getArticleById(val.target.value, 'news');
        const articleData = this.props.newsAndAnnouncementStore.selectedArticle;
        console.log(articleData);
        this.setState({
          article: articleData,
        });
        break;
      default:
        return (null);
    }
  };

  handleChange = (prop: any) => (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    // console.log(prop);
    // console.log(event.target.value);
    const newState: any = {
      [prop]: event.target.value,
    };
    this.setState(newState);
  };

  handleDeleteImageFromGallery = (prop: string, imageIndex: number) => {
    const oldGallery = this.state.image.concat() || [];
    oldGallery.splice(imageIndex, 1);
    const newState: any = {
      image: oldGallery,
    };
    this.setState(newState);
  };

  handleToggleButtonChange = (prop: string, value: boolean) => {
    const newState: any = {
      [prop]: value,
    };
    this.setState(newState);
  };

  render() {
    return (
      <div className={classes.flexColumn}>
        <PageTitleWithBackButton history={this.props.history} pageTitle={this.title} />
        {this.returnDropDownList(this.currentList, this.state.value,
          'Type', (val: any) => {
            this.setState({
              value: val.target.value,
            });
            if (val.target.value === 2) {
              this.props.homeStore.getPublishedAds(this.props.countryStore.managedCountries);
            } else if (val.target.value === 1) {
              this.props.homeStore.getArticles('news', this.props.countryStore.managedCountries);
            } else if (val.target.value === 3) {
              this.props.homeStore.getArticles('news', this.props.countryStore.managedCountries);
              this.props.homeStore.getPublishedAds(this.props.countryStore.managedCountries);
            }
          }, 'value', 'name')}
        {this.renderList()}
      </div>
    );
  }

  returnDropDownList = (list: any, value: any, label: any, onChange: any, id: any, name: any) => (
    <TextField
      select
      name={`Select${label}`}
      label={`Select ${label}`}
      className={classes.dropDownList}
      value={value}
      onChange={onChange}
      SelectProps={{
        MenuProps: {
          className: classes.menu,
        },
      }}
      variant="outlined"
    >
      {list.map((item: any, index: number) => (
        <MenuItem key={item[`${id}`]} value={item[`${id}`]}>
          {item[`${name}`]}
        </MenuItem>
      ))}
    </TextField>
  );

  renderInternalDropDownList = () => {
    switch (this.state.entityType) {
      case 'article':
        return (
          this.returnDropDownList(this.props.homeStore.articlesList, this.state.internalArticleId,
            'Article', (val: any) => this.setState({
              internalArticleId: val.target.value,
            }), 'articleId', 'title')
        );
        break;
      case 'branch':
        return (
          this.returnDropDownList(this.props.homeStore.branchesList, this.state.internalBranchId,
            'Branch', (val: any) => this.setState({
              internalBranchId: val.target.value,
            }), 'branchId', 'title')
        );
        break;
      case 'academy':
        return (
          this.returnDropDownList(this.props.homeStore.academiesList, this.state.internalAcademyId,
            'Academy', (val: any) => this.setState({
              internalAcademyId: val.target.value,
            }), 'academyId', 'title')
        );
        break;
      default:
        return (null);
    }
  };

  renderInternalLink = () => (
    <>
      {this.returnDropDownList(this.entityTypes, this.state.entityType,
        'Types', (val: any) => this.setState({
          entityType: val.target.value,
        }), 'value', 'name')}
      {this.renderInternalDropDownList()}
    </>
  );

  validInternalLink = () => {
    switch (this.state.entityType) {
      case 'article':
        return this.state.internalArticleId !== 0;
        break;
      case 'branch':
        return this.state.internalBranchId !== 0;
        break;
      case 'academy':
        return this.state.internalAcademyId !== 0;
        break;
      default:
        return false;
    }
  };

  handleChangeDropDown = (value: any, option: SelectOption | SelectOption[] | undefined) => {
    for (const article of this.props.homeStore.articlesList) {
      if (article.articleId === value) {
        this.handleState(value, 1);
        break;
      }
    }
  };

  renderList = () => {
    switch (this.state.value) {
      case 1:
        console.log(this.state.article);
        return (
          <div className={classes.flexColumn}>
            <p className={classes.titleHeader}>Layout style</p>

            <img className={classes.imageView} src={images.typeOne} />
            <p className={classes.titleHeader}>Layout Preview</p>

            {this.state.article && this.state.article.image && (
            <div className={classes.containerCard}>
              <div className={classes.bodyContainer}>
                <p className={classes.title}>{this.state.article.title}</p>
                <div className={classes.seprator} />
                <p className={classes.preview}>{this.state.article.preview}</p>
              </div>
              <div
                style={{
                  backgroundImage: `url(${this.state.article.image[0].imageUrl})`,
                  backgroundSize: 'cover',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-end',
                  width: '50%',
                }}
                className={classes.imageContainer}
              />
            </div>
            )}
            <div className={classes.selectDropDown}>
              <SingleSelect
                className={classes.singleSelect}
                value={this.state.articleId}
                placeholder=" Select Article"
                options={
                                            this.props.homeStore.articlesList.map((item) => {
                                              const structuredItem: SelectOption = {
                                                label: item.title, value: item.articleId,
                                              };
                                              return structuredItem;
                                            })
                                        }
                onChange={this.handleChangeDropDown}
              />
            </div>
            {/* {this.returnDropDownList(this.props.homeStore.articlesList, this.state.articleId,
                            'Article', (val: any) => this.handleState(val, 1), 'articleId', 'title')} */}
            <Button
              className={classes.buttonClass}
              disabled={this.props.homeStore.isLoading || this.state.articleId === 0}
              variant="contained"
              size="small"
              color="primary"
              onClick={() => this.submitHomeFeedPost()}
            >
Submit
            </Button>
          </div>
        );
        break;
      case 2:
        // console.log(this.state.ad, this.state.ad.backgroundImage[0].imageUrl)
        return (
          <div className={classes.flexColumn}>
            <p className={classes.titleHeader}>Layout style</p>

            <img className={classes.imageView} src={images.typeTwo} />
            <p className={classes.titleHeader}>Layout Preview</p>

            {this.state.ad && this.state.ad.backgroundImage
                        && this.state.ad.backgroundImage.length > 0 && (
                        <div className={classes.containerCard}>
                          <div
                            style={{
                              backgroundImage: `url(${this.state.ad.backgroundImage[0].imageUrl})`,
                              backgroundSize: 'cover',
                              alignItems: 'flex-start',
                              justifyContent: 'flex-end',
                              width: '100%',
                            }}
                            className={classes.imageContainer}
                          />
                        </div>
            )}
            {this.returnDropDownList(this.props.homeStore.adsList, this.state.advertisementId,
              'Ad', (val: any) => this.handleState(val, 2), 'advertisementId', 'title')}
            <Button
              className={classes.buttonClass}
              disabled={this.props.homeStore.isLoading || this.state.advertisementId === 0}
              variant="contained"
              size="small"
              color="primary"
              onClick={() => this.submitHomeFeedPost()}
            >
Submit
            </Button>

          </div>
        );
        break;
      case 3:
        return (
          <div className={classes.flexColumn}>
            <p className={classes.titleHeader}>Layout style</p>
            <img className={classes.image} src={images.typeThree} />
            <p className={classes.titleHeader}>Layout Preview</p>
            <div className={classes.largeContainerCard}>
              {this.state.article && this.state.article.image && (
              <div className={classes.containerWidth}>
                <div
                  style={{
                    backgroundImage: `url(${this.state.article.image[0].imageUrl})`,
                    backgroundSize: 'cover',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-end',
                    width: '100%',
                    height: '50%',
                  }}
                  className={classes.imageContainer}
                />
                <div className={classes.bodyContainerVertical}>
                  <p className={classes.title}>{this.state.article.title}</p>
                  <div className={classes.seprator} />
                  <p className={classes.preview}>{this.state.article.preview}</p>
                </div>
              </div>
              )}
              {this.state.ad && this.state.ad.backgroundImage
                        && this.state.ad.backgroundImage.length > 0 && (
                        <div className={classes.containerWidth}>
                          <div
                            style={{
                              backgroundImage: `url(${this.state.ad.backgroundImage[0].imageUrl})`,
                              backgroundSize: 'cover',
                              alignItems: 'flex-start',
                              justifyContent: 'flex-end',
                              width: '100%',
                              height: '100%',
                            }}
                            className={classes.imageContainer}
                          />
                        </div>
              )}
            </div>
            {this.returnDropDownList(this.props.homeStore.articlesList, this.state.articleId,
              'Article', (val: any) => this.handleState(val, 3, 'article'), 'articleId', 'title')}
            {this.returnDropDownList(this.props.homeStore.adsList, this.state.advertisementId,
              'Ad', (val: any) => this.handleState(val, 3, 'ad'), 'advertisementId', 'title')}
            <Button
              className={classes.buttonClass}
              disabled={this.props.homeStore.isLoading
                            || this.state.articleId === 0 || this.state.advertisementId === 0}
              variant="contained"
              size="small"
              color="primary"
              onClick={() => this.submitHomeFeedPost()}
            >
Submit
            </Button>

          </div>
        );
        break;
      case 4:
        return (
          <div className={classes.flexColumn}>
            <p className={classes.titleHeader}>Layout Style</p>

            <img className={classes.image} src={images.typeFour} />
            <p className={classes.titleHeader}>Layout Preview</p>

            <div className={classes.largeContainerCard}>
              {this.state.article && this.state.article.image && (
              <div className={classes.containerWidth}>
                <div
                  style={{
                    backgroundImage: `url(${this.state.article.image[0].imageUrl})`,
                    backgroundSize: 'cover',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-end',
                    width: '100%',
                    height: '50%',
                  }}
                  className={classes.imageContainer}
                />
                <div className={classes.bodyContainerVertical}>
                  <p className={classes.title}>{this.state.article.title}</p>
                  <div className={classes.seprator} />
                  <p className={classes.preview}>{this.state.article.preview}</p>
                </div>
              </div>
              )}
              {this.state.article2 && this.state.article2.image && (
              <div className={classes.containerWidth}>
                <div
                  style={{
                    backgroundImage: `url(${this.state.article2.image[0].imageUrl})`,
                    backgroundSize: 'cover',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-end',
                    width: '100%',
                    height: '50%',
                  }}
                  className={classes.imageContainer}
                />
                <div className={classes.bodyContainerVertical}>
                  <p className={classes.title}>{this.state.article2.title}</p>
                  <div className={classes.seprator} />
                  <p className={classes.preview}>{this.state.article2.preview}</p>
                </div>
              </div>
              )}
            </div>
            {this.returnDropDownList(this.props.homeStore.articlesList, this.state.articleId,
              'Article', (val: any) => this.handleState(val, 4), 'articleId', 'title')}
            {this.returnDropDownList(this.props.homeStore.articlesList, this.state.articleId_2,
              'Article', async (val: any) => {
                this.setState({
                  articleId_2: val.target.value,
                });
                await this.props.newsAndAnnouncementStore.getArticleById(val.target.value, 'news');
                const article2 = this.props.newsAndAnnouncementStore.selectedArticle;
                console.log(article2);
                this.setState({
                  article2,
                });
              }, 'articleId', 'title')}
            <Button
              className={classes.buttonClass}
              disabled={this.props.homeStore.isLoading || this.state.articleId === 0 || this.state.articleId_2 === 0}
              variant="contained"
              size="small"
              color="primary"
              onClick={() => this.submitHomeFeedPost()}
            >
Submit
            </Button>

          </div>
        );
        break;
      default:
        return (null);
    }
  };

  async componentDidMount() {
    const {
      countryStore, homeStore,
    } = this.props;
    await countryStore.getUserManagedCountries();

    homeStore.getBranches(countryStore.managedCountries);
    homeStore.getArticles('news', countryStore.managedCountries);
    homeStore.getAcademies(countryStore.managedCountries);
    homeStore.getHome(countryStore.managedCountries);
  }
}

export default Home;
